import ContextualGroupCards from './groups';

export default ContextualGroupCards;
